import DateBlock from "components/DateBlock";
import EventDate from "components/EventDate";
import style from "components/EventListing.module.scss";
import EventLocation from "components/EventLocation";
import EventTime from "components/EventTime";
import { ArrowRight, ChevronDown, ChevronUp } from "components/Icons";
import dayjs from "dayjs";
import { AnimatePresence, motion } from "framer-motion";
import { transitionDefaults } from "lib/constants";
import { getHref } from "lib/helpers";
import Link from "next/link";
import React, { useState } from "react";

const EventListing = ({ event }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const href = getHref(event);

  const eventStart = dayjs(event.startDateTime);
  const eventEnd = dayjs(event.endDateTime);

  return (
    <div className={style.root}>
      <div className={style.content}>
        <div className={style.details}>
          <div className={style.dateBlock}>
            <DateBlock date={eventStart} theme="dark" />
          </div>
          <div className={style.title}>
            <Link href={href}>
              {event.title}
            </Link>
          </div>
          <div className={style.date}>
            <EventDate event={event} iconTheme="dark" />
          </div>
          <div className={style.time}>
            <EventTime event={event} iconTheme="dark" />
          </div>
          {!!event.location && (
            <div className={style.location}>
              <EventLocation event={event} />
            </div>
          )}
          <div className={style.actions}>
            <div className={style.expandToggleButton}>
              <button
                className={style.expandToggle}
                onClick={handleExpandToggle}
                type="button"
              >
                {isExpanded ? <ChevronUp /> : <ChevronDown />}
              </button>
            </div>

            <Link href={href} className={style.linkButton} aria-label="See details">

              <ArrowRight />

            </Link>
          </div>
        </div>
        <AnimatePresence>
          {isExpanded && (
            <motion.div
              className={style.summaryContainer}
              initial={{ opacity: 0, height: 0, y: -20 }}
              animate={{ opacity: 1, height: "auto", y: 0 }}
              exit={{ opacity: 0, height: 0, y: -20 }}
              transition={transitionDefaults}
            >
              <div className={style.summary}>{event.summary}</div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default EventListing;
